class NovaProductCardAsync extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const productHandle = this.dataset.handle
    this.loadProductCard = this.loadProductCard.bind(this)

    this.loadProductCard(productHandle)
  }

  loadProductCard(productHandle) {
    fetch(`/products/${productHandle}?view=card`)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html')
        this.innerHTML = html.querySelector('.product-view-card').innerHTML
        window.NovaProductCardV2?.initWithin(this)
      })
  }
}

customElements.define('nova-product-card-async', NovaProductCardAsync)
